const styles = (theme) => ({
  perfectScrollbar: {
    maxHeight: '470px',
    padding: '0 12px',
  },
  document: {
    color: theme.palette.secondary.main,
  },
  starActive: {
    color: '#f5a623',
  },
  starInactive: {
    color: theme.palette.action.disabled,
  },
  logo: {
    fontSize: 0,
    width: '60px',
    [theme.breakpoints.up('md')]: {
      width: '100px',
    },
  },
  tableRow: {
    backgroundColor: '#F4F6F8',
    borderRadius: '10px',
    cursor: 'pointer',
    '& td:first-child': {
      borderRadius: '15px 0 0 15px',
    },
    '& td:last-child': {
      borderRadius: '0 15px 15px 0',
    },
  },
})

export default styles
